export default __webpack_public_path__ + "static/media/comfy2.f1981538.png";